import { useTranslation } from "@/packages/utils";
import type { NotificationRenderer } from "./types";
import { NotificationMetadataCard } from "../NotificationMetadataCard";
import { BodyCard } from "./BodyCard";
import type { NotificationDetail } from "../types";

function GenericContent({
  notification,
}: {
  notification: NotificationDetail;
}) {
  const { t } = useTranslation("inbox");

  const severityRaw = notification.metadata?.severity;
  const translatedSeverity = severityRaw
    ? t(`severityValues.${severityRaw}`, { defaultValue: severityRaw })
    : "";

  const bodyKey = `notificationBodies.${notification.category}`;
  const translatedBody = t(bodyKey, {
    defaultValue: "",
    findingTitle: notification.relatedEntityName,
    auditName: notification.metadata?.audit ?? "",
    severity: translatedSeverity,
  });

  const body = translatedBody || notification.body;

  return (
    <>
      <BodyCard body={body} delay={0.1} />
      {Object.keys(notification.metadata ?? {}).length > 0 && (
        <NotificationMetadataCard metadata={notification.metadata} />
      )}
    </>
  );
}

export const GenericRenderer: NotificationRenderer = {
  render: (notification) => <GenericContent notification={notification} />,
};
